import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, tap, finalize, delay } from 'rxjs/operators';

import { LoaderService } from '../../classes/loader/loader.service';
import { Router } from '@angular/router';
import { NotificationsService } from '../../classes/notifications/notifications.service';
import { Logger } from 'src/services/core/logger/logger.service';

const log = new Logger('HTTP');
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  errorMessage!: string;
  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private notification: NotificationsService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      request.url.includes('v1/menus') ||
      request.url.includes('v1/order/close-order') ||
      !request.url.includes('v1/menus/categories/') ||
      !request.url.includes('v1/menus/category/')
    ) {
      this.loaderService.hide();
    } else {
      this.loaderService.show();
    }

    return next.handle(request).pipe(
      tap((evt) => {
        // custom api errors
        if (evt instanceof HttpResponse) {
          this.loaderService.hide();
          if (evt.body.error == true) {
            this.errorMessage = evt.body.message;
            this.notification.publishMessages(this.errorMessage, 'danger', 1);
          }
          log.debug('evt', evt);
        }
      }),

      catchError((error: HttpErrorResponse) => {
        this.loaderService.hide();

        if (error.error instanceof ErrorEvent) {
          //client-side error
          this.errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          switch (error.status) {
            case 500:
            case 502:
            case 503: {
              this.errorMessage = 'An internal error occurred.';
              this.notification.publishMessages(this.errorMessage, 'danger', 1);
              break;
            }
            // @ts-ignore
            case '400 BAD_REQUEST':
            case 400: {
              this.errorMessage = error.error.message || error.statusText;
              this.notification.publishMessages(this.errorMessage, 'danger', 1);
              break;
            }
            case 409:
            case 404: {
              this.errorMessage = error.error.message || error.statusText;
              this.notification.publishMessages(this.errorMessage, 'danger', 1);
              break;
            }
            case 403: {
              this.notification.publishMessages(
                'You are not authorized for the operation',
                'danger',
                1
              );
              break;
            }
            // case 401: {
            //   this.notification.publishMessages(
            //     'Your session has expired',
            //     'danger',
            //     1
            //   );
            //   this.router.navigate(['/']);
            //   break;
            // }
            case 0: {
              this.errorMessage =
                'A connection error occurred. Please, check your network connection';
              this.notification.publishMessages(this.errorMessage, 'danger', 1);
              break;
            }
          }
        }

        return throwError(error.error);
      })
    );
  }
}
